import isInCountrySelectorDefinition from './is-in-country.js'
import isAllowedSelectorDefinition from './is-allowed.js'

export default [isAllowedSelectorDefinition, isInCountrySelectorDefinition]
